import { accessTokenClaims, accessSessionBinding } from './auth-session';

const KEY = 'pos_verified_session_v1';
export function saveOfflineSession(tenant, user, stores, token) {
  if (tenant?.kind !== 'tenant' || !['admin', 'cashier'].includes(user?.role)) return;
  const claims = accessTokenClaims(token);
  localStorage.setItem(KEY, JSON.stringify({ tenant, user, stores, session_id: claims?.sid || null, legacy_token: claims?.sid ? null : token }));
}
export function readOfflineSession() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY));
    const token = localStorage.getItem('pos_token');
    if (!value || !token || value.tenant.kind !== 'tenant') return null;
    const claims = accessTokenClaims(token);
    if (!Number.isFinite(claims.exp) || claims.exp * 1000 <= Date.now() || claims.aud !== value.tenant.id || claims.sub !== value.user.id) return null;
    const cachedBinding = value.session_id ? `sid:${value.session_id}` : value.legacy_token ? `legacy-token:${value.legacy_token}` : `legacy-token:${value.token || ''}`;
    if (cachedBinding !== accessSessionBinding(token)) return null;
    return value;
  } catch { return null; }
}
export const clearOfflineSession = () => localStorage.removeItem(KEY);
export function renewOfflineSessionToken(token) {
  try {
    const value = JSON.parse(localStorage.getItem(KEY));
    if (!value) return;
    const claims = accessTokenClaims(token);
    if (!claims || claims.aud !== value.tenant?.id || claims.sub !== value.user?.id) return;
    const oldBinding = value.session_id ? `sid:${value.session_id}` : value.legacy_token ? `legacy-token:${value.legacy_token}` : `legacy-token:${value.token || ''}`;
    if (oldBinding !== accessSessionBinding(token)) return;
    value.session_id = claims.sid || null;
    value.legacy_token = claims.sid ? null : token;
    delete value.token;
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch { /* Online session remains usable when offline-cache storage is unavailable. */ }
}
